import 'react-loading-skeleton/dist/skeleton.css';
import { SkeletonProps } from 'react-loading-skeleton';

import * as Styles from './styles';

export const Skeleton = (props: SkeletonProps) => (
  <Styles.Skeleton {...props} data-testid="skeleton" />
);
